import * as Sentry from "@sentry/browser";

// Récupérer le DSN depuis le meta tag
const sentryDsn = document.querySelector('meta[name="sentry-dsn"]')?.content;
const sentryEnvironment = document.querySelector('meta[name="sentry-environment"]')?.content || 'production';

// Initialiser Sentry seulement si le DSN est présent
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment,
    // Sentry 11 collecte par défaut infos utilisateur, cookies et corps des requêtes.
    // On garde le comportement restrictif de la v10 (et du SDK Ruby : send_default_pii false).
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      },
      httpBodies: [],
      urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      queues: false,
      graphQL: { document: false, variables: false },
    },

    // Performance Monitoring (0.2 = 20% des transactions)
    tracesSampleRate: 0.2,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Ignorer les erreurs non-actionnables
    ignoreErrors: [
      // WebGL / Mapbox sur navigateurs incompatibles
      "Failed to initialize WebGL",
      "WebGL is not supported",
      // Erreurs classiques de navigateur / extensions
      "ResizeObserver loop",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured",
      // Extensions navigateur
      "top.GLOBALS",
      "canvas.contentDocument",
      "MyApp_RemoveAllHighlights",
      "atomicFindClose",
      // Erreurs réseau génériques
      "Failed to fetch",
      "NetworkError when attempting to fetch resource",
      "Load failed",
    ],

    // Filtrer les erreurs provenant de scripts tiers / extensions
    beforeSend(event) {
      const frames = event.exception?.values?.[0]?.stacktrace?.frames;
      if (frames) {
        const lastFrame = frames[frames.length - 1];
        if (lastFrame?.filename) {
          // Ignorer les erreurs venant d'extensions navigateur ou scripts injectés
          if (
            lastFrame.filename.includes("extensions/") ||
            lastFrame.filename.includes("chrome-extension://") ||
            lastFrame.filename.includes("moz-extension://") ||
            lastFrame.filename.includes("safari-extension://")
          ) {
            return null;
          }
        }
      }
      return event;
    },
  });
}
